var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',_vm._l((_vm.contactList),function(contact){return _c('SocialIcon',{key:contact.title,attrs:{"link":contact.link,"title":contact.title,"src":contact.iconSrc,"opacity":0.2}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }